module.exports = __webpack_public_path__ + "img/b_head_portrait_man@2x.d2bd37a3.png";